// The purchase path below is intentionally retained in all chapter states.
// It is disabled by configuration, never by deletion.
// To re-enable: set the chapter's `state` to 'open' in src/config/chapters.ts

import { isPurchasable, type Chapter } from "@/config/chapters";
import { STATE_COPY } from "@/config/chapterCopy";
import { ShopifyBuyBox } from "@/components/shopify-buy-box";
import { ReleaseListForm } from "@/components/release-access";

export function ChapterBuyBlock({
  chapter,
  product,
}: {
  chapter: Chapter;
  /** Canonical slug, display price, and optional buy note. */
  product: { slug: string; price: string; buyNote?: string };
}) {
  const copy = STATE_COPY[chapter.state];

  // ── Purchasable path — the component re-enabled every quarter ──────────
  if (isPurchasable(chapter.state)) {
    return (
      <ShopifyBuyBox
        slug={product.slug}
        fallbackPrice={product.price}
        note={product.buyNote}
      />
    );
  }

  // ── Non-purchasable states: price shown, purchase path withheld ────────
  return (
    <div className="mt-6">
      <p
        className="font-display text-2xl text-muted-foreground/60"
        aria-disabled="true"
      >
        {product.price}
      </p>

      <p className="mt-4 max-w-md font-serif text-lg italic leading-relaxed text-muted-foreground">
        {copy.productNote}
      </p>

      <div className="mt-8 border-t border-border pt-8">
        <h2 className="font-display text-xs uppercase tracking-[0.24em] text-gold">
          Be notified when the next chapter opens.
        </h2>
        <div className="mt-5">
          <ReleaseListForm compact />
        </div>
      </div>
    </div>
  );
}
